import React from 'react';
import classes from './BackDrop.css';

const backDrop = (props) => (
    props.show ? <div className={classes.Backdrop} onClick={props.clicked}></div> : null
);

export default backDrop;


// WEBPACK FOOTER //
// ./src/Components/UI/BackDrop/BackDrop.js